import { ProductClassification } from 'enums';

export const TableColumns: string[] = [
  'Product',
  'Interest free offer',
  'Min. transaction',
  'Max. transaction',
  'Active status',
];

export const ProductName = new Map<ProductClassification, string>([
  [ProductClassification.ZipMoney, 'Zip Money'],
  [ProductClassification.ZipPlus, 'Zip Plus'],
  [ProductClassification.ZipPay, 'Zip Pay'],
]);
